<template>
  <div>
    <!-- Header Section Start -->
    <header id="hero-area">
      <div class="overlay"></div>
      <nav class="navbar navbar-expand-lg navbar-light fixed-top scrolling-navba bg-faded" id="white-bg">
        <div class="container">
          <!-- Brand and toggle get grouped for better mobile display -->
          <div class="navbar-header">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>
            <a class="navbar-brand" href="#"><img src="@/assets/img/logo.png" alt=""></a>
          </div>
          <div class="collapse navbar-collapse" id="navbarCollapse">
            <ul class="navbar-nav mr-auto w-100 justify-content-end">
              <li class="nav-item">
                <a class="nav-link" href="#hero-area" v-smooth-scroll>Home</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#about" v-smooth-scroll>About Us</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#services" v-smooth-scroll>Services</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#portfolio" v-smooth-scroll>Portfolio</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#contact" v-smooth-scroll>Contact</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <!-- Mobile Menu Start -->
      <ul class="mobile-menu">
        <li>
          <a href="#hero-area">Home</a>
        </li>
        <li>
          <a href="#about">About Us</a>
        </li>
        <li>
          <a href="#services">Services</a>
        </li>
        <li>
          <a href="#portfolio">Portfolio</a>
        </li>
        <li>
          <a href="#why">Why</a>
        </li>
        <li>
          <a href="#pricing">Pricing</a>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>
      <!-- Mobile Menu End -->

      <div class="container">
        <div class="row justify-content-md-center">
          <div class="col-md-10">
            <div class="carousel-slider owl-carousel owl-theme">
              <div class="item active">
                <div class="contents text-center">
                  <h1 class="wow fadeInDown" data-wow-duration="1000ms" data-wow-delay="300ms">Basic - Bootstrap 4 Template</h1>
                  <p class="lead  wow fadeIn" data-wow-duration="1000ms" data-wow-delay="400ms">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it.</p>
                  <a href="#" class="btn btn-common wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="400ms">Read More</a>
                  <a href="#" class="btn btn-border wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="400ms">Purchase</a>
                  <div class="banner_bottom_btn wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="700ms">
                    <a href="#about" class="arrow-down" v-smooth-scroll>
                      <font-awesome-icon size="2x" :icon="['far', 'arrow-alt-circle-down']" />
                    </a>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="contents text-center">
                  <h1 class="wow fadeInDown" data-wow-duration="1000ms" data-wow-delay="300ms">Digital Solution for Startups</h1>
                  <p class="lead  wow fadeIn" data-wow-duration="1000ms" data-wow-delay="400ms">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it.</p>
                  <a href="#" class="btn btn-border wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="400ms">Get Started</a>
                  <div class="banner_bottom_btn wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="700ms">
                    <a href="#about" class="arrow-down" v-smooth-scroll>
                      <font-awesome-icon size="2x" :icon="['far', 'arrow-alt-circle-down']" />
                    </a>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="contents text-center">
                  <h1 class="wow fadeInDown" data-wow-duration="1000ms" data-wow-delay="300ms">More Than Just a Template</h1>
                  <p class="lead  wow fadeIn" data-wow-duration="1000ms" data-wow-delay="400ms">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it.</p>
                  <a href="#" class="btn btn-common wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="400ms">Read More</a>
                  <a href="#" class="btn btn-border wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="400ms">Purchase</a>
                  <div class="banner_bottom_btn wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="700ms">
                    <a href="#about" class="arrow-down" v-smooth-scroll>
                      <font-awesome-icon size="2x" :icon="['far', 'arrow-alt-circle-down']" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </header>
    <!-- Header Section Start -->
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'Header',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  mounted () {
    $(window).on('scroll', function () {
      if ($(window).scrollTop() > 200) {
        $('.fixed-top').addClass('menu-bg')
      } else {
        $('.fixed-top').removeClass('menu-bg')
      }
    })
    this.buildCarousel()
  },
  methods: {
    buildCarousel () {
      $('.carousel-slider').owlCarousel({
        loop: true,
        nav: false,
        dots: true,
        navText: ['<i class="icon-arrow-left"></i>', '<i class="icon-arrow-right"></i>'],
        autoplay: true,
        autoplayTimeout: 3000,
        items: 1
      })
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Header.vue